// import React, { useState, useEffect } from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [showFooter, setShowFooter] = useState(false);

//   useEffect(() => {
//     const handleScroll = () => {
//       const scrollTop = window.scrollY || document.documentElement.scrollTop;
//       const windowHeight = window.innerHeight;
//       const documentHeight = document.documentElement.scrollHeight;

//       // Check if the user has reached the bottom of the page
//       if (scrollTop + windowHeight >= documentHeight - 1) {
//         setShowFooter(true);
//       } else {
//         setShowFooter(false);
//       }
//     };

//     // Add scroll event listener
//     window.addEventListener("scroll", handleScroll);

//     // Cleanup event listener on unmount
//     return () => window.removeEventListener("scroll", handleScroll);
//   }, []);

//   return (
//     <div className="flex flex-col min-h-screen background-gradient text-white">
//       <Navbar />
//       <main className="flex-grow w-full overflow-y-auto">{children}</main>
//       {showFooter && <Footer />} {/* Only render footer if showFooter is true */}
//     </div>
//   );
// };

// export default MainLayout;


// import React from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
//   <div className="flex flex-col min-h-screen bg-gradient-to-br background-gradient text-white">
//     {/* Navbar */}
//     <Navbar />

//     {/* Main Content */}
//     <main className="flex-grow w-full overflow-y-auto px-4 md:px-8 lg:px-16 py-8">
//       <div className="max-w-7xl mx-auto">{children}</div>
//     </main>

//     {/* Footer */}
//     <Footer />
//   </div>
// );

// export default MainLayout;


// import React from "react";
// import Navbar from "../components/Navbar";
// import Footer from "../components/Footer";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
//   <div className="flex flex-col min-h-screen background-gradient text-white">
//      <Navbar />
//     <main className="flex-grow w-full overflow-y-auto">{children}</main>
//     {/* <Footer /> */}
//   </div>
// );

// export default MainLayout;

// import React from "react";
// import { useLocation } from "react-router-dom";
// import Navbar from "../components/Navbar";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const location = useLocation();

//   // List of routes where the Navbar should not appear
//   const hideNavbarRoutes = [
//     "/services/ai-agents",
//     "/services/face-recognition",
//     "/services/ocr",
//     "/services/object-detection",
//     "/services/text-summarization",
//     "/services/language-translation",
//     "/services/sentiment-analysis",
//     "/services/chatbots",
//     "/services/recommendation-systems",
//     "/services/time-series-forecasting",
//   ];

//   // Check if the current route is in the list of routes where the Navbar is hidden
//   const shouldRenderNavbar = !hideNavbarRoutes.includes(location.pathname);

//   return (
//     <div className="flex flex-col min-h-screen background-gradient text-white">
//       {shouldRenderNavbar && <Navbar />}
//       <main className="flex-grow w-full overflow-y-auto">{children}</main>
//     </div>
//   );
// };

// export default MainLayout;

// import React from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from "../components/SideBar";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const location = useLocation();

//   // List of routes where the Sidebar should not appear
//   const hideSidebarRoutes = [
//     "/services/ai-agents",
//     "/services/face-recognition",
//     "/services/ocr",
//     "/services/object-detection",
//     "/services/text-summarization",
//     "/services/language-translation",
//     "/services/sentiment-analysis",
//     "/services/chatbots",
//     "/services/recommendation-systems",
//     "/services/time-series-forecasting",
//   ];

//   // Check if Sidebar should be displayed
//   const shouldRenderSidebar = !hideSidebarRoutes.includes(location.pathname);

//   return (
//     <div className="flex min-h-screen bg-black text-white">
//       {/* Sidebar */}
//       {shouldRenderSidebar && <Sidebar />}

//       {/* Main Content - Avoid Overlapping */}
//       <main
//         className={`flex-grow w-full overflow-y-auto p-6 md:p-10 transition-all duration-300 ${
//           shouldRenderSidebar ? "ml-64" : "ml-0"
//         }`}
//       >
//         {children}
//       </main>
//     </div>
//   );
// };

// export default MainLayout;

// import React, { useState } from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from "../components/SideBar";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const location = useLocation();

//   // List of routes where the Sidebar should not appear
//   const hideSidebarRoutes = [
//     "/services/ai-agents",
//     "/services/face-recognition",
//     "/services/ocr",
//     "/services/object-detection",
//     "/services/text-summarization",
//     "/services/language-translation",
//     "/services/sentiment-analysis",
//     "/services/chatbots",
//     "/services/recommendation-systems",
//     "/services/time-series-forecasting",
//   ];

//   const shouldRenderSidebar = !hideSidebarRoutes.includes(location.pathname);

//   return (
//     <div className="flex min-h-screen bg-black text-white transition-all duration-300 overflow-hidden">
//       {/* Sidebar (Fixed & Always Takes Space) */}
//       {shouldRenderSidebar && <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />}

//       {/* Main Content Area (Fixes Gap & Adjusts Based on Sidebar Toggle) */}
//       <main
//         className={`flex-grow w-full overflow-y-auto p-6 transition-all duration-300 ${
//           shouldRenderSidebar ? (isSidebarOpen ? "pl-34" : "pl-20") : "pl-0"
//         }`}
//       >
//         {children}
//       </main>
//     </div>
//   );
// };

// export default MainLayout;


// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from "../components/SideBar";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const location = useLocation();

//   // Hide Sidebar for Certain Routes
//   const hideSidebarRoutes = [
//     "/services/ai-agents",
//     "/services/face-recognition",
//     "/services/ocr",
//     "/services/object-detection",
//     "/services/text-summarization",
//     "/services/language-translation",
//     "/services/sentiment-analysis",
//     "/services/chatbots",
//     "/services/recommendation-systems",
//     "/services/time-series-forecasting",
//   ];

//   const shouldRenderSidebar = !hideSidebarRoutes.includes(location.pathname);

//   // Detect screen width for responsiveness
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   // Automatically close sidebar on small screens
//   useEffect(() => {
//     if (windowWidth < 768) {
//       setIsSidebarOpen(false);
//     }
//   }, [windowWidth]);

//   return (
//     <div className="flex min-h-screen bg-black text-white transition-all duration-300">
//       {/* Sidebar (Only Renders if Allowed) */}
//       {shouldRenderSidebar && (
//         <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
//       )}

//       {/* Main Content (Adapts Based on Sidebar State) */}
//       <main
//         className={`flex-grow w-full overflow-y-auto p-6 transition-all duration-300 ${
//           shouldRenderSidebar
//             ? isSidebarOpen
//               ? "pl-54" // Sidebar Open (Desktop)
//               : "pl-20" // Sidebar Collapsed
//             : "pl-0" // No Sidebar
//         }`}
//       >
//         {children}
//       </main>
//     </div>
//   );
// };

// export default MainLayout;


// import React, { useState, useEffect } from "react";
// import { useLocation } from "react-router-dom";
// import Sidebar from "../components/SideBar";

// const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [isSidebarOpen, setIsSidebarOpen] = useState(true);
//   const [windowWidth, setWindowWidth] = useState(window.innerWidth);
//   const location = useLocation();

//   // Hide Sidebar for Specific Routes
//   const hideSidebarRoutes = [
//     "/services/ai-agents",
//     "/services/face-recognition",
//     "/services/ocr",
//     "/services/object-detection",
//     "/services/text-summarization",
//     "/services/language-translation",
//     "/services/sentiment-analysis",
//     "/services/chatbots",
//     "/services/recommendation-systems",
//     "/services/time-series-forecasting",
//   ];

//   const shouldRenderSidebar = !hideSidebarRoutes.includes(location.pathname);

//   // Auto-hide sidebar on smaller screens
//   useEffect(() => {
//     const handleResize = () => setWindowWidth(window.innerWidth);
//     window.addEventListener("resize", handleResize);

//     return () => window.removeEventListener("resize", handleResize);
//   }, []);

//   useEffect(() => {
//     if (windowWidth < 768) {
//       setIsSidebarOpen(false);
//     }
//   }, [windowWidth]);

//   return (
//     <div className="flex min-h-screen bg-black text-white transition-all duration-300">
//       {/* ✅ Sidebar now exists ONLY inside MainLayout */}
//       {shouldRenderSidebar && (
//         <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
//       )}

//       {/* Adjust content layout based on sidebar state */}
//       <main
//         className={`flex-grow w-full overflow-y-auto p-6 transition-all duration-300 ${
//           shouldRenderSidebar
//             ? isSidebarOpen
//               ? "pl-64" // Sidebar Open
//               : "pl-20" // Sidebar Collapsed
//             : "pl-0" // No Sidebar
//         }`}
//       >
//         {children}
//       </main>
//     </div>
//   );
// };

// export default MainLayout;



import React, { useState, useEffect } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../components/SideBar";
import Breadcrumbs from "../components/Breadcrumbs";

const MainLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const location = useLocation();

  // Hide Sidebar for Specific Routes
  const hideSidebarRoutes = [
    "/services/ai-agents",
    "/services/face-recognition",
    "/services/ocr",
    "/services/object-detection",
    "/services/text-summarization",
    "/services/language-translation",
    "/services/sentiment-analysis",
    "/services/chatbots",
    "/services/recommendation-systems",
    "/services/time-series-forecasting",
  ];

  const shouldRenderSidebar = !hideSidebarRoutes.includes(location.pathname);

  // Auto-hide sidebar on smaller screens
  useEffect(() => {
    const handleResize = () => setWindowWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
    if (windowWidth < 768) {
      setIsSidebarOpen(false);
    }
  }, [windowWidth]);

  return (
    <div className="flex min-h-screen bg-black text-white transition-all duration-300">
      {/* Sidebar */}
      {shouldRenderSidebar && (
        <Sidebar isOpen={isSidebarOpen} setIsOpen={setIsSidebarOpen} />
      )}

      {/* Main Content Wrapper */}
      <div className={`flex flex-col flex-grow w-full transition-all duration-300 ${shouldRenderSidebar
          ? isSidebarOpen
            ? "ml-64" // Sidebar Open
            : "ml-20" // Sidebar Collapsed
          : "ml-0" // No Sidebar
        }`}>
        {/* Breadcrumbs - Sticky at the top */}
        <div className="sticky top-0 z-40 bg-black/80 backdrop-blur-sm border-b border-white/10">
          <div className={`w-full transition-all duration-300 ${shouldRenderSidebar && !isSidebarOpen ? "pl-16" : "pl-6"
            }`}>
            <Breadcrumbs />
          </div>
        </div>

        {/* Main Content */}
        <main className="flex-grow w-full overflow-y-auto p-6">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;